import {Component, OnInit, Inject} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';
import {APP_CONFIG} from '@synthroneApp/app.config';
import {MatDialog} from '@angular/material';
import {SectionModel} from '@synthroneApp/models/section/section.model';

@Component({
    selector: 'app-section-add-view',
    templateUrl: './section-add-view.component.html',
    styleUrls: ['./section-add-view.component.scss']
})

export class SectionAddViewComponent implements OnInit {

    dataId: number;
    isLoading = true;
    actionName: string;
    pageTypes: any;
    public section: SectionModel;
    isDataLoading = false;

    constructor(private _router: Router, protected api: ApiService,
                private messagesService: MessagesService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog) {
        this.actionName = (this._router.url.includes('add') ? 'Add' : 'Edit');
    }

    ngOnInit() {
        this.pageTypes = [];

        this.section = {
            name: '',
            title: '',
            icon: '',
            pageType: ''
        };

        this.api.makeRequest('api_system_pagetype_list', {}, 'crafter').catch(
            (err: any) => {
                const errorMsg = err || 'Could not get list of pageTypes';
                return Observable.throw(errorMsg)
            }).subscribe(
            (result) => {
                this.pageTypes = result.data;

                if (this.actionName === 'Edit') {
                    this.dataId = parseInt((this._router.url).match(/\d+/)[0]);

                    this.api.makeRequest('api_system_section_details', {
                        id: this.dataId
                    }, 'crafter').subscribe(
                        (result) => {
                            this.section = {
                                name: result['name'],
                                title: result['title'],
                                icon: result['title'],
                                pageType: result['pageType']['id']
                            };
                            this.isLoading = false;
                        },
                        (error) => {
                            this.isLoading = false;
                            this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result => {
                                this.homeReturnFN();
                            });
                        });
                } else {
                    this.isLoading = false;
                }
            },
            (error) => {
                this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result => {
                    this.homeReturnFN();
                });
            });

    }

    homeReturnFN = () => {
        this._router.navigate(['/sections']);
    };

    createOrgFN = () => {
        this.api.makeRequest('api_system_section_add', this.section, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    editOrgFN = () => {
        this.isLoading = true;
        this.section.id = this.dataId;
        this.api.makeRequest('api_system_section_edit', this.section, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    submitFN(isValid: boolean) {
        if (this.actionName === 'Add') {
            this.createOrgFN();
        } else {
            this.editOrgFN();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/views/section-add-view/section-add-view.component.ts